export default __webpack_public_path__ + "static/media/world.30e9bfd4.svg";